import { render, staticRenderFns } from "./medium.pug?vue&type=template&id=333e8e73&lang=pug&"
import script from "./ArticleMedium.vue?vue&type=script&lang=js&"
export * from "./ArticleMedium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports